export default class SessionStorageManager{
    static readSessionStorage = (name, defaultValue) => {
        let sessionState = JSON.parse(sessionStorage.getItem(name));
        return sessionState || defaultValue
    }
    static writeSessionStorage = (name, values) => {
        sessionStorage.setItem(name, JSON.stringify(values))
    }
}